import { render, staticRenderFns } from "./CompensatoryLeavesEmployeeLeaveDetails.vue?vue&type=template&id=2bbcd184"
import script from "./CompensatoryLeavesEmployeeLeaveDetails.vue?vue&type=script&lang=js"
export * from "./CompensatoryLeavesEmployeeLeaveDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports